import React from 'react';
import { FormTemplate, TextInput } from 'ui-builder';
import { ProjectTypeDropdown } from 'features/tasks-forms';
import { Plan, ProjectType, useProjectDetailsFieldsAdminService } from 'nekst-api';
import useSettingsNavigator from '../../../settingsNavigator';
import { useStateContext } from '../StateContext';

interface FormType {
  name: string,
  projectType: ProjectType,
}

export default function CreatePlanFromFieldsForm(
  props: {
    setupAreaId: number,
    setupAreaVersion: string,
    projectType?: ProjectType,
  }
) {
  const projectDetailsFieldsAdminService = useProjectDetailsFieldsAdminService();

  const settingsNavigator = useSettingsNavigator();

  const stateContext = useStateContext();

  return (
    <FormTemplate<FormType, Plan>
      title="Create Plan from Fields"
      submitFormFunc={async (data) => {
        return projectDetailsFieldsAdminService.createPlanFromFields(
          props.setupAreaId,
          props.setupAreaVersion,
          data.projectType,
          data.name
        );
      }}
      afterSubmitFunc={async (data) => {
        settingsNavigator.openAdminMarketPlanPage(
          stateContext.id,
          props.setupAreaId,
          props.setupAreaVersion,
          data.id
        )
      }}
      initialData={{
        projectType: props.projectType
      }}
      validationSchema={{
        name: {
          type: 'string',
          constraints: {
            required: true,
            minLength: 3,
            maxLength: 50,
          }
        },
        projectType: {
          type: 'string',
          constraints: {
            required: true,
          }
        }
      }}
    >
      <ProjectTypeDropdown source="projectType" label="Transaction Type" />
      <TextInput source="name" label="Plan Name" />
    </FormTemplate>
  );
}
